<template>
  <asc-stacked-chart
    :title="title"
    :values="getData"
    :series-name="seriesName"
    :category-name="categoryName"
    :loading="loading"
    :options="getBarChartOptions"
  ></asc-stacked-chart>
</template>

<script>
import AscStackedChart from './AscStackedChart'

export default {
  name: 'AscBarChart',

  components: {
    AscStackedChart,
  },

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    seriesName: {
      type: String,
      default: '',
    },
    categoryName: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    onClick: {
      type: Function,
      default: () => {},
    },
    maxCategoriesVisible: {
      type: Number,
      default: null,
    },
    allowDecimals: {
      type: Boolean,
      default: undefined,
    },
  },

  data() {
    return {
      initData: [],
    }
  },

  computed: {
    getData() {
      return this.values.length > 0 ? this.values : this.initData
    },
    buildXAxisOptions() {
      const xAxis = { lineWidth: 0, allowDecimals: this.allowDecimals }
      return this.values && this.maxCategoriesVisible
        ? this.values.length &&
          this.values.length >= this.maxCategoriesVisible + 1
          ? {
              ...xAxis,
              ...{
                max: this.maxCategoriesVisible - 1,
                scrollbar: {
                  enabled: true,
                  barBackgroundColor: 'rgba(0,0,0,0.35)',
                  rifleColor: 'none',
                  barBorderRadius: 5.5,
                  buttonBackgroundColor: 'none',
                  buttonBorderWidth: 0,
                  buttonBorderRadius: 0,
                  trackBackgroundColor: 'none',
                  trackBorderWidth: 0,
                  height: 8,
                },
              },
            }
          : xAxis
        : xAxis
    },
    getBarChartOptions() {
      return {
        plotOptions: {
          series: {
            pointWidth: 8,
            cursor: 'default',
          },
        },
        xAxis: this.buildXAxisOptions,
        yAxis: { allowDecimals: this.allowDecimals },
      }
    },
  },
}
</script>
